module.exports = __webpack_public_path__ + "static/img/fall.0cbae06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fall.jpg
// module id = T6oQ
// module chunks = 1